
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-info",
      function () {
        return require("private-next-pages/medical-info.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-info"])
      });
    }
  